import React from 'react';
import InventoryIcon from '@mui/icons-material/Inventory';
import { Box, Typography } from '@mui/material';

import { SkuOption } from './skuSelectInputUtils';

export interface SkuOptionRowProps {
  option: SkuOption;
}

export const SkuOptionRow = ({ option }: SkuOptionRowProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      py: 0.25,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        maxWidth: '100%',
      }}
    >
      <Typography
        component="span"
        color="text.primary"
        sx={{
          wordBreak: 'break-word',
          display: '-webkit-box',
          overflow: 'hidden',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          fontWeight: 500,
        }}
      >
        {option.name ?? option.label ?? ''}
      </Typography>
      <Typography
        component="span"
        variant="caption"
        color="text.secondary"
        sx={{ mt: '2px', maxWidth: '100%', wordBreak: 'break-word' }}
      >
        {option.key}
      </Typography>
    </Box>
    {option.isGeneric && <InventoryIcon fontSize="small" sx={{ color: 'text.disabled' }} />}
  </Box>
);
